import React from 'react';
import { Trans } from '@lingui/react/macro';

import OnOffSwitch from '@rover/components/src/buttons/OnOffSwitch';
import { Box, Flex, Link, Text } from '@rover/kibble/core';

type Props = {
  label: string;
  onChange: (value: boolean) => void;
  value: boolean;
  starSitterLink: string;
};

const StarSitterFilterLeftToggle = ({
  label,
  onChange,
  value,
  starSitterLink,
}: Props): JSX.Element => (
  <Box>
    <Flex alignItems="center" gap="2x">
      <OnOffSwitch on={value} onToggle={onChange} hideLabel ariaLabelledby="star-sitter-label" />
      <Flex flexDirection="column">
        <Text size="100" fontWeight="semibold" webProps={{ id: 'star-sitter-label' }}>
          {label}
        </Text>
        <Text size="100">
          <Link href={starSitterLink}>
            <Trans>Learn more about the program</Trans>
          </Link>
        </Text>
      </Flex>
    </Flex>
  </Box>
);

export default StarSitterFilterLeftToggle;
